module.exports = __webpack_public_path__ + "static/media/SubscriptionThankYou1.8ced2165.gif";


//////////////////
// WEBPACK FOOTER
// ./src/SubscriptionThankYou1.gif
// module id = 605
// module chunks = 0